const LinkedInIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z" fill="#1275B1"/>
        <path d="M9.58471 7.49439C9.58471 8.16193 9.00607 8.70307 8.29236 8.70307C7.5786 8.70307 7 8.16193 7 7.49439C7 6.82686 7.5786 6.28571 8.29236 6.28571C9.00607 6.28571 9.58471 6.82686 9.58471 7.49439Z" fill="white"/>
        <path d="M7.17648 9.59138H9.38561V16.2856H7.17648V9.59138Z" fill="white"/>
        <path d="M12.9424 9.59174H10.7333V16.286H12.9424C12.9424 16.286 12.9424 14.1785 12.9424 12.8609C12.9424 12.07 13.2125 11.2756 14.29 11.2756C15.5077 11.2756 15.5004 12.3106 15.4947 13.1125C15.4873 14.1605 15.505 15.2302 15.505 16.286H17.7141V12.7529C17.6954 10.4969 17.1075 9.45745 15.1736 9.45745C14.0251 9.45745 13.3132 9.97888 12.9424 10.4506V9.59174Z" fill="white"/>
        </svg>
        
);
};
export default LinkedInIcon;
